<template>
  <v-toolbar flat :color="backgroundColor">
    <v-row align="center" justify="center" class="fill-height">
      <v-col class="pa-0">
        <div class="wall-header" :style="{ color: textColor }">
          <div v-if="teamMode === true && team" class="d-none d-sm-flex align-start">
            <v-img
              v-if="eventLogo"
              :src="eventLogo"
              gradient="#88888888, #88888888"
              contain
              max-height="50px"
              max-width="100px"
              :alt="eventName"
              :title="eventName"
            ></v-img>
            <div class="ma-2" v-else>
              <h5>{{ eventName }}</h5>
            </div>
          </div>
          <div v-if="teamMode === true && team" class="team-header d-flex align-center">
            <v-img
              v-if="team.brandingLogoUrl"
              :src="team.brandingLogoUrl"
              contain
              max-height="50px"
              max-width="100px"
              :alt="team.name"
              :title="team.name"
            ></v-img>
            <div class="mx-2 d-none d-md-block">
              <h3>{{ team.name }}</h3>
            </div>
            <div class="ml-5 text-center" v-if="isRunning">
              <v-tooltip left>
                <template v-slot:activator="{ on }">
                  <h2 class="mb-0" :hover="on">
                    <v-icon :color="textColor">mdi-run</v-icon>
                    {{ (Math.round(declaredDistance / 100) / 10) | number }} km
                  </h2>
                </template>
                <span>{{ $t("wall.header.declaredDistance") }}</span>
              </v-tooltip>
            </div>
          </div>
          <div v-else class="wall-header-text">
            <div class="d-none d-md-block">
              {{ $t("wall.header.title") }}
            </div>
            <div v-if="pHashtag || hashtag" class="hashtag">#{{ pHashtag || hashtag }}</div>
          </div>
          <div class="wall-header-actions">
            <v-btn icon :color="textColor" v-if="pFacebook || facebook" @click="goTo(pFacebook || facebook)">
              <v-icon>mdi-facebook</v-icon>
            </v-btn>
            <v-btn icon :color="textColor" v-if="pInstagram || instagram" @click="goTo(pInstagram || instagram)">
              <v-icon>mdi-instagram</v-icon>
            </v-btn>
            <v-btn icon :color="textColor" v-if="pTwitter || twitter" @click="goTo(pTwitter || twitter)">
              <v-icon>mdi-twitter</v-icon>
            </v-btn>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-toolbar>
</template>
<script>
export default {
  name: "WallHeader",
  props: {
    pHashtag: String,
    pFacebook: String,
    pInstagram: String,
    pTwitter: String,
    teamMode: Boolean,
    team: Object,
    declaredDistance: Number,
    isRunning: Boolean,
  },
  computed: {
    textColor() {
      return this.$store.state.selectedActivity && this.$store.state.selectedActivity.event.brandingTextColor;
    },
    backgroundColor() {
      return (
        this.$store.state.selectedActivity && this.$store.state.selectedActivity.event.brandingContentBackgroundColor
      );
    },
    eventLogo() {
      return this.$store.state.selectedActivity && this.$store.state.selectedActivity.event.brandingLogoUrl;
    },
    eventName() {
      return this.$store.state.selectedActivity && this.$store.state.selectedActivity.event.name;
    },
    hashtag() {
      let hash = this.$route.query.hashtag;
      if (!hash) return "";

      if (!!hash && hash[0] === "#") {
        hash = hash.substr(1);
      }
      return hash.toUpperCase();
    },
    facebook() {
      return this.$route.query.facebook;
    },
    instagram() {
      return this.$route.query.instagram;
    },
    twitter() {
      return this.$route.query.twitter;
    },
  },
  methods: {
    goTo(page) {
      window.open(page, "_blank");
    },
  },
};
</script>

<style scoped lang="scss">
.wall-header {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-content: center;
}
.wall-header-text {
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  letter-spacing: 1px;
  font-weight: 600;
}
.wall-header-text * {
  white-space: nowrap;
}
.wall-header-actions {
  display: none;
  min-height: 48px;
}
@media (min-width: 960px) {
  .wall-header-actions {
    display: initial;
  }
  .wall-header-text {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }
}
.team-header {
  margin-left: auto;
  margin-right: auto;
}
</style>

<style lang="scss">
.wall-expanded .wall-header {
  padding: 0 50px;
}
</style>
